<template>
  <div>
    <el-table :data="pageMaterialList" border>
      <el-table-column
        label="序号"
        prop="index"
        align="center"
        type="index"
        width="60"
        fixed="left"
      />
      <el-table-column
        :label="nameConfig.columnName"
        min-width="200px"
        fixed="left"
      >
        <template slot-scope="{ row }">
          <span>{{ row[nameConfig.defineCode] || '-' }}</span>
        </template>
      </el-table-column>
      <el-table-column label="采购量/计量单位" min-width="90px">
        <template slot-scope="{ row }">
          <span>
            {{ row[numConfig.defineCode] }}/{{ row[unitConfig.defineCode] }}
          </span>
        </template>
      </el-table-column>
      <el-table-column v-if="modelConfig.isEnable" label="参数型号">
        <template slot-scope="{ row }">
          <span>{{ row[modelConfig.defineCode] || '-' }}</span>
        </template>
      </el-table-column>
      <el-table-column label="采购人指定" min-width="340px">
        <template slot-scope="{ row }">
          <div
            v-for="item in purchaseSpecifyConfig"
            :key="item.defineCode"
            class="info-item"
          >
            <span class="info-item-label">{{ item.columnName || '-' }}</span>
            <span class="info-item-value">
              {{ row[item.defineCode] || '-' }}
            </span>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="供应商响应" min-width="340px">
        <template>
          <div
            v-for="item in supplierResponseConfig"
            :key="item.defineCode"
            class="info-item"
          >
            <span class="info-item-label">{{ item.columnName || '-' }}</span>
            <span class="info-item-value">
              供应商需响应
            </span>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="对供应商备注" min-width="100px">
        <template slot-scope="{ row }">
          <span>{{ row.remarks || '-' }}</span>
        </template>
      </el-table-column>
      <el-table-column label="附件" min-width="160px">
        <template slot-scope="{ row }">
          <upload
            v-if="row.attachmentFileIds && row.attachmentFileIds[0]"
            :props-data="{
              disabled: true,
              uploadMode: 'fileId',
              fileIdBefore: row.attachmentFileIds[0]
            }"
          />
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        min-width="120px"
        align="center"
        fixed="right"
      >
        <template slot-scope="{ row, $index }">
          <a-button
            type="link"
            @click="lookDetail(row, $index)"
          >查看详情</a-button>
        </template>
      </el-table-column>
    </el-table>

    <pagination
      v-show="table.length > size"
      :total="table.length"
      size="small"
      :page.sync="page"
      :limit.sync="size"
    />

    <!-- 采购项详情弹窗 -->
    <purchase-list-item
      v-model="purchaseListItemVisible"
      :info="currentRow"
      :config="columnConfig"
      :read-only="true"
      :in-supplier="true"
    />
  </div>
</template>

<script>
import Pagination from '@/components/common/Pagination'
import Upload from '@/components/common/Upload'
import PurchaseListItem from '@/components/common/PurchaseListComponent/PurchaseListItem'

import materialColumnMixin from '@/components/common/PurchaseListComponent/material-column-mixin'
import { cloneDeep } from 'lodash'

/**
 * @description 供应商端查看采购清单列表
 */
export default {
  name: 'PurchaseListSupplier',

  components: {
    Upload,
    Pagination,
    PurchaseListItem
  },

  mixins: [materialColumnMixin],

  props: {
    // 回显的表格数据
    tableData: {
      type: Array,
      default: () => []
    },

    // 外部传入的模板配置
    itemSchemaList: {
      type: Array,
      default: () => []
    }
  },

  data() {
    return {
      table: [],

      // 当前操作的采购项
      currentRow: {},
      // 当前操作的采购项下标
      currentRowIndex: -1,
      pageMaterialList: [], // 分页显示的列表
      page: 1,
      size: 10,

      // 控制采购项详情弹窗显示
      purchaseListItemVisible: false
    }
  },

  watch: {
    tableData: {
      handler(val) {
        this.table = cloneDeep(this.tableData)
        this.getPageData()
      },
      deep: true,
      immediate: true
    },

    itemSchemaList: {
      handler(val) {
        if (val.length > 0) {
          this.columnConfig = cloneDeep(val)
          this.setSupplierConfig()
        }
      },
      deep: true,
      immediate: true
    },

    size(val) {
      this.getPageData()
    },

    page(val) {
      this.getPageData()
    }
  },

  methods: {
    /**
     * @description: 前端分页，获取当前页数据
     */
    getPageData() {
      const start = (this.page - 1) * this.size
      const end = start + this.size
      this.pageMaterialList = this.table.slice(start, end)
    },

    /**
     * 查看采购项详情
     */
    lookDetail(row, index) {
      this.currentRowIndex = index
      this.currentRow = row
      this.purchaseListItemVisible = true
    }
  }
}
</script>

<style lang="scss" scoped>
.info-item {
  display: flex;
  align-items: stretch;
  margin: 24px 0;
  line-height: 22px;

  &:first-child {
    margin-top: 16px;
  }
  &:last-child {
    margin-bottom: 16px;
  }

  .info-item-label {
    color: $text-color;
    width: 40%;
    margin-right: 24px;
    font-weight: bold;
  }
  .info-item-value {
    flex: 1;
    color: $second-text-color;
  }
}
</style>
